module.exports = __webpack_public_path__ + "static/assets/c540cc6d4fe3f69efe10d5f050f76c86.png";